/**
 * Aba Exportação automática (C6) — embute o PainelAgendamentos existente
 * (auto-suficiente via AgendamentoContext) dentro do shell .set-section.
 */
import React from "react";

import PainelAgendamentos from "../../../components/Agendamento/PainelAgendamentos";

export default function ExportacaoTab() {
  return (
    <section className="set-section">
      <div className="set-section__head">
        <h2 className="set-section__title">Exportação automática</h2>
        <p className="set-section__desc">
          Exporta automaticamente para uma pasta do Windows enquanto o app está aberto.
          PDF/Excel/CSV usam o snapshot do painel; PNG/JPG capturam a página.
        </p>
      </div>
      <div className="set-section__body">
        <PainelAgendamentos />
      </div>
    </section>
  );
}
